import gsap from 'gsap';

export const animatePinDevice = (trigger: string, endTrigger: string, pin: string) =>
  gsap.timeline({ scrollTrigger: { trigger, endTrigger, pin } });
